(function() {

  'use strict';

  /* Wireless ResetVoicemailPassword Confirmation Controller - START */
  eclipseApp.controller('resetVoicemailPasswordConfirmCtrl', ['$scope', '$rootScope', '$stateParams', '$sessionStorage', 'uteLocale', 'env', 'commonService', function($scope, $rootScope, $stateParams, $sessionStorage, uteLocale, env, commonService) {

  console.log('Inside Reset Voicemail Password Controller');

  $scope.$extend({

    accountDetails : commonService.accountDetails,
    selectedBAN : $stateParams.accountNumber,
    selectedCTN : $stateParams.subscriberNo,
    confirmedPassword : $stateParams.confirmedPd,
    $storage : $sessionStorage,
    language : uteLocale.language,
    subscriberNumberList : [],
    resetVoicemailPasswordInfo : null,
    resetVoicemailPasswordInfoError : null,
    voiceMessagingFAQLink : null,

    relaunchPage : function () {
      if($scope.language.toLowerCase() == 'fr'){
        $scope.voiceMessagingFAQLink = env.frVoiceMessagingFAQLink;
      }else{
        $scope.voiceMessagingFAQLink = env.enVoiceMessagingFAQLink;
      }
    }
  });

  $scope.relaunchPage();

  }]);

  /* Wireless ResetVoicemailPassword Confirmation Controller - END */

})();
